import { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import { ChevronUp, Ticket } from "lucide-react";
import { Drawer, DrawerContent, DrawerTitle } from "@/components/ui/drawer";
import { ParlaySlip } from "@/components/ParlaySlip";
import { useSlip } from "@/context/SlipContext";
import { useAuth } from "@/context/AuthContext";
import { fmtOdds, money, parlayMath } from "@/lib/odds";

const HIDDEN = ["/", "/login", "/register", "/builder", "/builder-locked", "/pricing", "/payment/success", "/payment/cancel"];

export function MobileSlip() {
  const { user } = useAuth();
  const { legs, wager } = useSlip();
  const { pathname } = useLocation();
  const [open, setOpen] = useState(false);
  const [bump, setBump] = useState(false);
  useEffect(() => {
    if (!legs.length) return;
    setBump(true);
    const t = setTimeout(() => setBump(false), 500);
    return () => clearTimeout(t);
  }, [legs.length]);
  useEffect(() => setOpen(false), [pathname]);
  if (!user || HIDDEN.includes(pathname) || pathname.startsWith("/t/") || pathname.startsWith("/p/")) return null;
  const m = parlayMath(legs, Number(wager) || 0);

  return (
    <>
      <div className="h-20 lg:hidden" aria-hidden />
      <button data-testid="mobile-slip-bar" onClick={() => setOpen(true)} className={`fixed inset-x-3 bottom-3 z-40 flex items-center gap-3 rounded-2xl border border-emerald-500/40 bg-[#121824]/95 px-4 py-3 text-left shadow-[0_-8px_40px_rgba(16,185,129,0.15)] backdrop-blur-xl transition-transform duration-300 lg:hidden ${bump ? "scale-[1.02]" : ""}`}>
        <span className="relative flex h-10 w-10 shrink-0 items-center justify-center rounded-xl bg-emerald-500/15 text-emerald-400">
          <Ticket size={18} />
          {legs.length > 0 && <span data-testid="mobile-slip-count" className="absolute -right-1.5 -top-1.5 flex h-5 min-w-5 items-center justify-center rounded-full bg-emerald-500 px-1 font-mono-num text-[11px] font-bold text-[#0B0E14]">{legs.length}</span>}
        </span>
        <span className="min-w-0 flex-1">
          <span className="block font-display text-lg font-bold uppercase leading-none tracking-tight text-white">Parlay Slip</span>
          <span className="block truncate text-xs text-slate-400" data-testid="mobile-slip-summary">{legs.length ? `${legs.length} legs · ${fmtOdds(m.american)} · to win ${money(m.payout)}` : "Tap a pick to start building — swipe up anytime"}</span>
        </span>
        <ChevronUp size={18} className="text-slate-400" />
      </button>
      <Drawer open={open} onOpenChange={setOpen} shouldScaleBackground={false}>
        <DrawerContent data-testid="mobile-slip-drawer" className="max-h-[92vh] border-[#26334D] !bg-[#0B0E14] lg:hidden">
          <DrawerTitle className="sr-only">Parlay slip</DrawerTitle>
          <div className="overflow-y-auto px-3 pb-6 pt-2"><ParlaySlip full /></div>
        </DrawerContent>
      </Drawer>
    </>
  );
}
